import {NotificationBase} from './NotificationBase';

export class InvitationNotif extends NotificationBase {
  public inviteID: string = '';

  constructor(obj?: Record<string, unknown>) {
    super();
    Object.assign(this, obj);
  }
}
